import styled, { css } from 'styled-components';
import MaskedInput from 'react-text-mask';

const baseInputStyles = css`
  display: block;
  box-sizing: border-box;
  margin: 0;
  border: 0;
  outline: none;
  width: ${props => props.width};
  height: ${props => props.height};
  line-height: ${props => props.height};
  font-size: ${props => props.fontSize};
  letter-spacing: ${props => props.letterSpacing};
  font-family: ${props => props.theme.fonts[props.font]};

  &::placeholder {
    color: #9b9b9b;
    text-align: left;
  }
  &::-ms-clear {
    height: 0;
    width: 0;
  }

  &:focus {
    ${props =>
      props.haserror !== 'true' && !props.disabled
        ? css`
            border-color: ${props.theme.colors.brand};
            box-shadow: 0 2px 4px 0 rgba(36, 75, 137, 0.25);
          `
        : ''};
  }
`;

const borderedInputStyles = css`
  border-width: 1px;
  border-style: solid;
  border-radius: 6px;
  padding: ${props => props.innerPadding || '0 16px 0 11px'};

  ${props => {
    if (props.disabled) {
      return css`
        border-color: rgba(0, 0, 0, 0.03);
        background-color: #f8f8f8;
      `;
    } else if (props.haserror === 'true') {
      return css`
        border-color: #ed1c1c;
        background-color: rgba(238, 29, 29, 0.05);
      `;
    }
    return css`
      border-color: #9b9a9b;
      background-color: transparent;
    `;
  }};
`;

const InputStyles = css`
  ${baseInputStyles};
  ${borderedInputStyles};
`;

const InputMaskElement = styled(MaskedInput)`
  ${InputStyles};
`;

const InputElement = styled.input`
  ${InputStyles};
`;

export { InputElement, InputMaskElement };



// WEBPACK FOOTER //
// ./src/components/units/Input/InputUnits.js